<template>
  <header class="chat-header">
    <div class="header-left">
      <button class="back-btn" @click="$emit('back')">
        <span class="back-icon">←</span>
        <span>返回首页</span>
      </button>
      <h1 class="header-title">{{ title }}</h1>
    </div>
    <div class="header-right">
      <button class="new-chat-btn" @click="$emit('new-chat')" v-if="showNewChat">
        <span>+ 新对话</span>
      </button>
    </div>
  </header>
</template>

<script>
export default {
  name: 'ChatHeader',
  props: {
    title: {
      type: String,
      default: ''
    },
    toolType: {
      type: String,
      default: 'chat'
    }
  },
  computed: {
    showNewChat() {
      return this.toolType === 'chat'
    }
  }
}
</script>

<style scoped>
.chat-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 100;
}
.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
}
.back-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
}
.back-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}
.back-icon {
  font-size: 18px;
}
.header-title {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
}
.new-chat-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.5);
  color: white;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}
.new-chat-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: white;
}
@media (max-width: 768px) {
  .chat-header {
    padding: 12px 16px;
  }
  .header-title {
    font-size: 16px;
  }
  .back-btn span:last-child {
    display: none;
  }
}
</style>
